// ***************************************
// Definition of game token BirdTrail
// ***************************************
import { tbContainer } from "../engine/tbContainer";
import { tbGame } from "../engine/tbGame";
import { tbVector } from "../engine/tbVector";
import { PhysicsSettings } from "../settings/PhysicsSettings";
import { s_trail_splash, s_aiming_dot } from "./AssetDefinitions/ImageDefinitions";
// The constructor for the BirdTrail game token. 
export var BirdTrail = function (parentContainer, birdArray) {
    "use strict";
    // Properties used by the engine
    this.depth = undefined;
    this.layer = 0;
    this.visible = true;
    this.active = true;
    this.birds = birdArray;
    this.container = new tbContainer();
    this.parentContainer = parentContainer;
    this.parentContainer.addChild(this.container);
    // Add it to the game engine
    tbGame.addToken(this);
};
// handleAdd is called when the token is (re-) added to the game. 
BirdTrail.prototype.handleAdd = function () {
    "use strict";
};
// handleRemove is called when the token is removed from the game.
BirdTrail.prototype.handleRemove = function () {
    "use strict";
    this.parentContainer.removeChild(this.container);
    this.container.free();
    this.container = null;
};
// handleEndStep is called each step after processing other events (before draw).
BirdTrail.prototype.handleEndStep = function (timePassed) {
    "use strict";
    for (var i = 0; i < this.birds.length; i++) {
        var bird = this.birds[i];
        if ((!bird.isDead() && bird.firstContact) || bird.isDead()) {
            continue;
        }
        var pt = new tbVector(bird.x, bird.y);
        if (bird.prevTrailDot) {
            var dist = bird.prevTrailDot.distance(pt);
            var ratio = this.isSpecial ? 1 : (bird.velocity.length() / PhysicsSettings.slingshotMaxForce);
            var neededDist = PhysicsSettings.birdTrailDistBetweenDots * ratio;
            if (dist < neededDist) {
                continue;
            }
            var v = pt.subtract(bird.prevTrailDot).normalize().scale(neededDist);
            bird.prevTrailDot.x += v.x;
            bird.prevTrailDot.y += v.y;
        }
        else {
            bird.prevTrailDot = pt.clone();
            if (!this.isSpecial) {
                continue;
            }
        }
        var scale = (1 / PhysicsSettings.textureResolution);
        var sprite = null;
        if (this.isSpecial) {
            sprite = s_trail_splash.clone();
            sprite.setScale(scale * 0.3, scale * 0.3);
            this.isSpecial = false;
        }
        else {
            sprite = s_aiming_dot.clone();
            sprite.setScale(scale * 0.5, scale * 0.5);
        }
        sprite.setPosition(bird.prevTrailDot.x, bird.prevTrailDot.y);
        this.container.addChild(sprite);
    }
};
BirdTrail.prototype.usedSpecialAbility = function () {
    "use strict";
    this.isSpecial = true;
};
